/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';

import { API_URL, ENDPOINTS } from '../../../constants/api';
import { CURRENT_YEAR } from '../../../constants';
import ProjectDetail from './projectDetail';
import ProjectsList from './projectsList';

const Galmudug = () => {
  const [company, setCompany] = useState(null);
  const [carousel, setCarousel] = useState([]);
  const [about, setAbout] = useState([]);
  const [services, setServices] = useState([]);
  const [facts, setFacts] = useState([]);

  const [contact, setContact] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);
  const [links, setLinks] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [agreed, setAgreed] = useState(false);
  const [requirement, setRequirement] = useState({
    local: '',
    international: '',
  });
  const [sponser, setSponser] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [currentSection, setCurrentSection] = useState('home');

  const apiKey =
    '3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943';

  useEffect(() => {
    axios
      .get(`${API_URL}/api/sys/web-info`)
      .then((res) => {
        const data = res.data;
        setCompany(data.company[0]);
        setCarousel(data.carousel);
        setAbout(data.about);
        setServices(data.services);
        setFacts(data.facts);

        setContact(data.contact);
        setPricing(data.pricing);
        setEvents(data.events);
        setNews(data.news);
        console.log('events: ', data.events);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/requirements`;
    if (!selectedOption) return; // Optional: skip if no type selected

    const fetchForm = async () => {
      try {
        const response = await axios.get(url, {
          headers: { 'x-api-key': apiKey },
        });
        // setRequirement(response.data.link);
        const result = {};
        response.data.report.forEach((item) => {
          const type = item.Type.toLowerCase();
          result[type] = item.Requirement;
        });

        setRequirement(result);
      } catch (error) {
        console.error('Error fetching data:', error);
        // setLink([]);
        // setInputs([]);
        // setLoading(false);
      }
    };
    fetchForm();
    console.log('res requirement: ', requirement);
  }, [selectedOption]);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/recent-projects`;
    const url2 = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/ktc_web_important_link-report`;
    const url3 = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/ngo_sponser-report`;

    const fetchProjects = async () => {
      try {
        const response = await axios.get(url, {
          headers: { 'x-api-key': apiKey },
        });

        const response2 = await axios.get(url2, {
          headers: { 'x-api-key': apiKey },
        });

        const response3 = await axios.get(url3, {
          headers: { 'x-api-key': apiKey },
        });
        // setRequirement(response.data.link);
        setProjects(response.data.report);
        console.log('projects: ', response.data.report);
        setLinks(response2.data.report);
        setSponser(response3.data.report);
        console.log('sponsers: ', sponser);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchProjects();
  }, []);

  if (!company) return <div className="text-center mt-5">Loading...</div>;

  const handleSelect = (type) => {
    setSelectedOption(type);
    setAgreed(false);
    setShowOptions(false);
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <div className="container">
          <a className="navbar-brand" href="#home">
            <img
              src={`${API_URL}/${company.logo}`}
              alt="Logo"
              width="40"
              height="40"
              className="d-inline-block align-top me-2"
            />
            {company.name}
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse ms-5" id="navbarNav">
            {/* Left-side nav items */}
            <ul
              className="navbar-nav me-auto p-4"
              style={{ fontSize: '21px', color: 'black' }}
            >
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#home"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentSection('home');
                  }}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentSection('projects');
                  }}
                >
                  View Projects
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/portal/send-us-message">
                  Contact Us
                </a>
              </li>
            </ul>

            {/* Right-side nav items */}
            <ul className="navbar-nav ms-auto d-flex align-items-center">
              {/* Apply Button */}
              <li className="nav-item me-2 position-relative">
                <button
                  className="btn btn-primary"
                  onClick={() => setShowOptions(!showOptions)}
                >
                  <FeatherIcon icon="clipboard" className="me-2" /> Apply
                </button>
                {showOptions && (
                  <div className="dropdown-menu show position-absolute mt-2">
                    <button
                      className="dropdown-item"
                      onClick={() => handleSelect('local')}
                    >
                      Local NGO
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => handleSelect('international')}
                    >
                      International NGO
                    </button>
                  </div>
                )}
                {selectedOption && (
                  <div
                    className="modal fade show"
                    style={{
                      display: 'block',
                      backgroundColor: 'rgba(0,0,0,0.5)',
                    }}
                    tabIndex="-1"
                    role="dialog"
                    aria-modal="true"
                  >
                    <div
                      className="modal-dialog modal-lg modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">
                            {selectedOption === 'local'
                              ? 'Local NGO Requirements'
                              : 'International NGO Requirements'}
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setSelectedOption(null)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <pre
                            className="fw-b"
                            style={{ whiteSpace: 'pre-wrap' }}
                          >
                            {requirement[selectedOption]}
                          </pre>
                          <div className="form-check mt-3">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="agreeCheckModal"
                              checked={agreed}
                              onChange={() => setAgreed(!agreed)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="agreeCheckModal"
                            >
                              {selectedOption === 'local'
                                ? 'Waan Aqriyey Waana Aqbalay Shuruudaha.'
                                : 'I have read and agree to the requirements.'}
                            </label>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <a
                            href={
                              selectedOption === 'local'
                                ? '/portal/Online-Local-NGO-Registration'
                                : '/portal/Online-INT-NGO-Registration'
                            }
                            className={`btn btn-success ${!agreed ? 'disabled' : ''}`}
                          >
                            {selectedOption === 'local'
                              ? 'U gudub diiwaangelinta'
                              : 'Proceed to Registration'}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>

              {/* Login Dropdown */}
              <li className="nav-item">
                <a
                  href="/login/NGO-user-portal-login"
                  className="btn btn-primary d-flex align-items-center gap-2"
                >
                  <FeatherIcon icon="log-in" className="me-2" />
                  Login
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* facts */}
      <div className="main-content" style={{ marginTop: '90px' }}>
        {currentSection === 'home' && (
          <>
            <div
              className="row py-5 ms-5 me-5"
              id="facts"
              style={{ marginTop: '90px' }}
            >
              {facts.map((fact, idx) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={idx}>
                  <div
                    className="card text-bg-light h-100"
                    style={{
                      minHeight: '180px', // Increased height
                      fontFamily: `'Roboto', system-ui, sans-serif`,
                    }}
                  >
                    <div className="card-header" style={{ fontSize: '20px' }}>
                      {fact.header}
                    </div>
                    <div className="card-body d-flex flex-column justify-content-center">
                      <div
                        className="d-flex justify-content-between align-items-center w-100"
                        style={{ fontSize: '22px' }}
                      >
                        <FeatherIcon
                          icon={fact.icon}
                          size={80}
                          color={fact.color}
                        />
                        <div className="text-end">
                          <h3
                            className="mb-0"
                            style={{ color: `${fact.color}` }}
                          >
                            {fact.fact_value}
                          </h3>
                          <p
                            className="mb-0"
                            style={{ color: `${fact.color}` }}
                          >
                            {fact.fact_title}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/*  about */}
            <div className="row" style={{ marginTop: '2' }} id="facts">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <div
                  className="card text-bg-light mb-3 ms-5"
                  style={{ maxWidth: '110rem' }}
                >
                  <div className="card-header" style={{ fontSize: '25px' }}>
                    {about[0]?.title}
                  </div>
                  <div className="card-body">
                    <p
                      className="card-text text-justify"
                      style={{ fontSize: '23px', color: 'black' }}
                      dangerouslySetInnerHTML={{
                        __html: about[0]?.description.replace(/\n/g, '<br />'),
                      }}
                    ></p>
                  </div>
                </div>
                {/*  recent projects */}
                <div
                  className="card text-bg-light mb-3 mb-3 ms-5"
                  style={{ maxWidth: '110rem' }}
                >
                  <div className="card-header" style={{ fontSize: '25px' }}>
                    Recently Updated Projects
                  </div>
                  <div
                    className="card-body bg-white"
                    style={{ fontSize: '21px' }}
                  >
                    <div className="container">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th width="60%">Project</th>
                            <th width="20%">Project Value(USD)</th>
                            <th width="10%">Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projects.slice(0, 5).map((project, index) => (
                            <tr key={project.ID || index}>
                              <td>{project.name}</td>
                              <td>{project.BudgetAllocated || 'N/A'}</td>{' '}
                              {/* Fallback if `budget` is missing */}
                              <td>
                                <button
                                  onClick={() =>
                                    setSelectedProjectId(project.ID)
                                  }
                                  className="btn btn-warning btn-sm"
                                >
                                  View Detail
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Sponsers */}
                <div
                  className="card text-bg-light mb-3 mb-3 ms-5"
                  style={{ maxWidth: '110rem' }}
                >
                  <div className="card-header" style={{ fontSize: '25px' }}>
                    Sponsers
                  </div>
                  <div
                    className="card-body bg-white"
                    style={{ fontSize: '21px' }}
                  >
                    <div className="container">
                      <div className="row">
                        {sponser.map((sponser, index) => (
                          <div className="col-md-3 mt-5">
                            <div className="row">
                              <img
                                width={50}
                                height={50}
                                src={`${API_URL}/${sponser.Image}`}
                                style={{
                                  maxWidth: '60%',
                                  maxHeight: '60%',
                                  objectFit: 'fit',
                                }}
                                title={`${sponser.Name}`}
                              ></img>
                              <span>{sponser.Name}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* important links */}
              <div className="col-4">
                <div className="card text-bg-light mb-3 ms-2 me-4">
                  <div
                    className="card-header"
                    style={{ fontSize: '21px', fontWeight: 'bold' }}
                  >
                    Learn About {company.name}
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <iframe
                          src={`${about[0]?.link1}`}
                          width="100%"
                          height="250px"
                          frameBorder="0"
                          allowfullscreen=""
                        ></iframe>
                      </div>
                      <div className="col-md-12">
                        <iframe
                          src={`${about[0]?.link2}`}
                          width="100%"
                          height="250px"
                          frameBorder="0"
                          allowfullscreen=""
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card text-bg-white mb-3 ms-2 me-4">
                  <div
                    className="card-header"
                    style={{ fontSize: '21px', fontWeight: 'bold' }}
                  >
                    Important Links
                  </div>
                  <div className="card-body" style={{ fontSize: '21px' }}>
                    <div className="container">
                      <table className="table table-condensed small">
                        <tbody>
                          {links.map((link, index) => (
                            <tr>
                              <td>
                                <a
                                  target="_blank"
                                  href={`${link.Link}`}
                                  style={{
                                    textDecoration: 'none',
                                    backgroundColor: 'transparent',
                                  }}
                                >
                                  {' '}
                                  {link.Title}{' '}
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div />

            {selectedProjectId && (
              <ProjectDetail
                projects={projects}
                project_id={selectedProjectId}
                onClose={() => setSelectedProjectId(null)}
              />
            )}

            {/* Events */}
            <section id="events" className="p-5">
              <div className="container-fluid">
                <h2 className="text-center mb-4">Recent Events</h2>
                <div className="row row-cols-1 row-cols-md-3 g-4">
                  {events
                    .slice(-3)
                    .reverse()
                    .map((event, index) => (
                      <div className="col">
                        <div className="card h-100">
                          <img
                            src={`${API_URL}/${event?.image_url.replace('public/', '')}`}
                            className="card-img-top"
                            alt="..."
                          />
                          <div className="card-body">
                            <h5 className="card-title">{event.title}</h5>
                            <p className="card-text" style={{ color: 'black' }}>
                              {event.description}
                            </p>
                          </div>
                          <div className="card-footer">
                            <small className="text-body-secondary">
                              {new Date(event.date).toLocaleDateString(
                                'en-GB',
                                {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                }
                              )}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </section>

            {/* Contact */}
            <section id="structure" className="p-5">
              <div className="container-fluid">
                <h2 className="text-center mb-4">Ministry Structure</h2>
                {contact[0]?.organization_structure && (
                  <div className="map-responsive">
                    <img
                      src={`${API_URL}/${contact[0]?.organization_structure.replace('public/', '')}`}
                      width="100%"
                      height="650"
                      style={{ border: 0 }}
                    ></img>
                  </div>
                )}
              </div>
            </section>

            <section id="contact" className="p-5">
              <div className="container-fluid">
                <h2 className="text-center mb-4">Contact Us</h2>

                {/* Contact Information */}
                <p className="text-center">
                  Email: {contact[0]?.email} <br />
                  Phone: {contact[0]?.phone} <br />
                  Address: {contact[0]?.address}
                </p>

                {/* Map Section */}
                {contact[0]?.map_url && (
                  <div className="map-responsive">
                    <iframe
                      src={contact[0]?.map_url}
                      width="100%"
                      height="450"
                      frameBorder="0"
                      style={{ border: 0 }}
                      allowFullScreen
                      aria-hidden="false"
                      tabIndex="0"
                    ></iframe>
                  </div>
                )}
              </div>
            </section>
          </>
        )}
        {/* projects list */}
        {currentSection === 'projects' && <ProjectsList projects={projects} />}
      </div>
      {/* Footer */}
      <footer className="text-center p-4 bg-dark text-white">
        &copy; {CURRENT_YEAR} {company.name}. All rights reserved.
      </footer>
    </div>
  );
};

export default Galmudug;
